import { extendTheme } from "@chakra-ui/react";

export const theme=extendTheme({
    colors:{
        brand:'#79d392',
        brand_secondary:'#2d2c2c'
    }
})